import { render, staticRenderFns } from "./LoyaltyPromotionRestrictionTable.vue?vue&type=template&id=142a93c8&scoped=true&"
import script from "./LoyaltyPromotionRestrictionTable.vue?vue&type=script&lang=js&"
export * from "./LoyaltyPromotionRestrictionTable.vue?vue&type=script&lang=js&"
import style0 from "./LoyaltyPromotionRestrictionTable.vue?vue&type=style&index=0&id=142a93c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142a93c8",
  null
  
)

export default component.exports